import {
  REQUEST_MORE_FEED_RESULT,
  RECEIVE_MORE_FEED_RESULT,
  HANDLE_MORE_FEED_RESULT_ERROR
} from '../actions/feed'

function feedReducer (state = null, action) {
  switch (action.type) {
    case REQUEST_MORE_FEED_RESULT:
      return {
        ...state,
        receivedResult: false,
        requestedMore: true
      }
    case RECEIVE_MORE_FEED_RESULT:
      return {
        ...state,
        page: state.page + 1,
        receivedResult: true,
        requestedMore: false,
        results: state.results.concat(action.result)
      }
    case HANDLE_MORE_FEED_RESULT_ERROR:
      return {
        ...state,
        receivedResult: true,
        requestedMore: false
      }
    default:
      return state
  }
}

export default feedReducer



// WEBPACK FOOTER //
// ./src/shared/reducers/feed.js